export interface IMenuFooter {
  title: string;
  menu: IMenu[];
}
interface IMenu {
  href: string;
  title: string;
  target?: boolean;
  rel?: "dofollow" | "noopener" | "dofollow noopener" | "nofollow" | "nofollow noopener";
}
export const modelMenuFooter: IMenuFooter[] = [
  {
    title: "Sapo.vn",
    menu: [
      {
        title: "Về chúng tôi",
        href: "https://www.sapo.vn/ve-chung-toi.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_brand_ve_chung_toi",
        target: true,
        rel: "dofollow",
      },
      {
        title: "Sapo là gì?",
        href: "https://www.sapo.vn/sapo-la-gi.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_brand_sapo-la-gi",
        target: true,
      },
      {
        title: "Blog Sapo",
        href: "https://www.sapo.vn/blog?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_blog_blog_sapo",
        target: true,
        rel: "noopener",
      },
      {
        title: "Bảng giá",
        href: "https://www.sapo.vn/bang-gia.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_bang_gia",
        target: true,
        rel: "dofollow",
      },
      {
        title: "Tuyển dụng",
        href: "https://tuyendung.sapo.vn/?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_brand_tuyen_dung_sapo",
        target: true,
        rel: "noopener",
      },
      {
        title: "Profile Sản Phẩm",
        href: "https://www.sapo.vn/profile-san-pham?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_profile_san_pham",
        target: true,
      },
      {
        title: "Sapo Academy",
        href: "https://academy.sapo.vn/?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_sapo_academy",
        target: true,
      },
    ],
  },

  {
    title: "Sản phẩm",
    menu: [
      {
        title: "Phần mềm quản lý bán hàng",
        href: "https://www.sapo.vn/phan-mem-quan-ly-ban-hang.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_phan_mem_quan_ly_ban_hang",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Phần mềm bán hàng online",
        href: "https://www.sapo.vn/phan-mem-quan-ly-ban-hang-online.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_phan_mem_ban_hang_online",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Thiết kế website",
        href: "https://www.sapo.vn/thiet-ke-website.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_thiet_ke_website",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Phần mềm quản lý nhà hàng",
        href: "https://www.sapo.vn/phan-mem-quan-ly-nha-hang.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_phan_mem_quan_ly_nha_hang",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Phần mềm bán hàng hợp kênh",
        href: "https://www.sapo.vn/omnichannel.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_phan_mem_ban_hang_hop_kenh",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Quản lý & phát triển thương hiệu",
        href: "https://www.sapo.vn/enterprise?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_quan_ly_phat_trien_thuong_hieu",
        rel: "dofollow",
        target: true,
      },
    ],
  },

  {
    title: "Thiết kế website",
    menu: [
      {
        title: "Thiết kế website bán hàng",
        href: "https://www.sapo.vn/thiet-ke-website-ban-hang.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_thiet_ke_website_ban_hang",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Thiết kế web thời trang",
        href: "https://www.sapo.vn/thiet-ke-web-thoi-trang.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_thiet_ke_web_thoi_trang",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Thiết kế web doanh nghiệp",
        href: "https://www.sapo.vn/thiet-ke-website.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_thiet_ke_web_doanh_nghiep",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Thiết kế website bất động sản",
        href: "https://www.sapo.vn/thiet-ke-web-bat-dong-san.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_thiet_ke_website_bat_dong_san",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Thiết kế web thương mại điện tử",
        href: "https://www.sapo.vn/thiet-ke-web-thuong-mai-dien-tu.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_thiet_ke_web_thuong_mai_dien_tu",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Thiết kế website giá rẻ",
        href: "https://www.sapo.vn/thiet-ke-website.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_thiet_ke_website_gia_re",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Mẫu website đẹp",
        href: "https://themes.sapo.vn/?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_mau_website_dep",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Đăng ký tên miền",
        href: "https://www.sapo.vn/dang-ky-ten-mien.html",
        rel: "dofollow",
        target: true,
      },
    ],
  },
  {
    title: "Giải pháp quản lý",
    menu: [
      {
        title: "Quản lý siêu thị mini",
        href: "https://www.sapo.vn/phan-mem-quan-ly-sieu-thi-mini.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_quan_ly_sieu_thi_mini",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Quản lý cửa hàng tạp hóa",
        href: "https://www.sapo.vn/phan-mem-quan-ly-cua-hang-tap-hoa.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_quan_ly_cua_hang_tap_hoa",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Quản lý cửa hàng thời trang",
        href: "https://www.sapo.vn/phan-mem-quan-ly-cua-hang-thoi-trang.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_quan_ly_cua_hang_thoi_trang",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Quản lý cửa hàng mỹ phẩm",
        href: "https://www.sapo.vn/phan-mem-quan-ly-cua-hang-my-pham.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_quan_ly_cua_hang_my_pham",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Quản lý quán cafe",
        href: "https://www.sapo.vn/phan-mem-quan-ly-quan-cafe.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_quan_ly_quan_cafe",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Quản lý quán bida",
        href: "https://www.sapo.vn/phan-mem-quan-ly-quan-bida.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_quan_ly_quan_bida",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Quản lý nhà thuốc",
        href: "https://www.sapo.vn/phan-mem-quan-ly-nha-thuoc.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_quan_ly_nha_thuoc",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Quản lý trà sữa",
        href: "https://www.sapo.vn/phan-mem-quan-ly-quan-tra-sua.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_quan_ly_tra_sua",
        rel: "dofollow",
        target: true,
      },
    ],
  },
  {
    title: "Thiết bị bán hàng",
    menu: [
      {
        title: "Máy in hóa đơn",
        href: "https://shop.sapo.vn/may-in-hoa-don-may-in-bill?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_may_in_hoa_don",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Máy in mã vạch",
        href: "https://shop.sapo.vn/may-in-ma-vach?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_may_in_ma_vach",
        rel: "dofollow",
        target: true,
      },
      {
        title: "Máy quét mã vạch",
        href: "https://shop.sapo.vn/may-quet-ma-vach?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_may_quet_ma_vach",
        rel: "dofollow",
        target: true,
      },
    ],
  },
];

export const modelAddressFooter: IMenuFooter[] = [
  {
    title: "Trợ giúp",
    menu: [
      {
        title: "Trung tâm trợ giúp",
        href: "https://support.sapo.vn/?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_trung_tam_tro_giup",
        rel: "nofollow noopener",
        target: true,
      },
      {
        title: "Hình thức thanh toán",
        href: "https://support.sapo.vn/cac-hinh-thuc-thanh-toan-khi-su-dung-dich-vu-cua-sapo?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_hinh_thuc_thanh_toan",
        rel: "nofollow noopener",
        target: true,
      },
      {
        title: "Hướng dẫn đăng nhập Sapo",
        href: "https://support.sapo.vn/?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_huong_dan_dang_nhap_sapo",
        rel: "nofollow noopener",
        target: true,
      },
      {
        title: "Điều khoản & Điều kiện sử dụng",
        href: "https://support.sapo.vn/dieu-khoan-dieu-kien-su-dung?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_dieu_khoan_dieu_kien_su_dung",
        rel: "nofollow noopener",
        target: true,
      },
      {
        title: "Chính sách bảo vệ dữ liệu cá nhân",
        href: "https://support.sapo.vn/chinh-sach-bao-ve-du-lieu-ca-nhan?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_chinh_sach_bao_ve_du_lieu_ca_nhan",
        rel: "nofollow noopener",
        target: true,
      },
      {
        title: "Dịch vụ hoàn thiện website",
        href: "https://drive.google.com/file/d/1rxszgN-JqCDLALdT0rSouOKmLPNoTFC1/view",
        rel: "nofollow noopener",
        target: true,
      },
      {
        title: "Liên hệ",
        href: "https://www.sapo.vn/lien-he.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_brand_lien_he",
        rel: "nofollow noopener",
        target: true,
      },
    ],
  },
  {
    title: "Tổng đài hỗ trợ",
    menu: [
      {
        title: "Tư vấn dịch vụ: 1800 6750",
        href: "tel:18006750",
        rel: "noopener",
        target: true,
      },
      {
        title: "Hỗ trợ sử dụng: 1900 6750",
        href: "tel:19006750",
        rel: "noopener",
        target: true,
      },
      {
        title: "Email: support@sapo.vn",
        href: "mailto:support@sapo.vn",
        rel: "noopener",
        target: true,
      },
      {
        title: "Từ 7h00 – 22h00 các ngày từ thứ 2 đến Chủ nhật",
        href: null,
        rel: "noopener",
        target: true,
      },
    ],
  },
  {
    title: "Dịch vụ",
    menu: [
      {
        title: "Đăng ký tên miền",
        href: "//www.sapo.vn/dang-ky-ten-mien.html",
        rel: "noopener",
        target: true,
      },
      {
        title: "Dịch vụ chiến lược nội dung",
        href: "//www.sapo.vn/xay-dung-chien-luoc-noi-dung.html",
        rel: "noopener",
        target: true,
      },
      {
        title: "Dịch vụ chăm sóc nội dung",
        href: "//www.sapo.vn/cham-soc-noi-dung.html",
        rel: "noopener",
        target: true,
      },
    ],
  },
  {
    title: "Thiết bị bán hàng",
    menu: [
      {
        title: "Máy in hóa đơn",
        href: "https://shop.sapo.vn/may-in-hoa-don-may-in-bill",
        rel: "nofollow noopener",
        target: true,
      },
      {
        title: "Máy in mã vạch",
        href: "https://shop.sapo.vn/may-in-ma-vach",
        rel: "nofollow noopener",
        target: true,
      },
      {
        title: "Máy quét mã vạch",
        href: "https://shop.sapo.vn/may-quet-ma-vach",
        rel: "nofollow noopener",
        target: true,
      },
    ],
  },
];
